import { MODELS_INFO, type ModelName } from "@butler/shared";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

const availableModels = MODELS_INFO;
export const ModelSelector = ({
  selectedModel,
  onModelChange,
  disabled,
  className,
}: {
  selectedModel?: ModelName;
  onModelChange?: (model: ModelName) => void;
  disabled?: boolean;
  className?: string;
}) => {
  if (!onModelChange) return null;

  return (
    <Select
      value={selectedModel}
      onValueChange={(e) => onModelChange(e as ModelName)}
      disabled={disabled}
    >
      <SelectTrigger className="w-[180px]">
        <SelectValue placeholder="Select Model" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>OpenAI</SelectLabel>
          {availableModels
            .filter((m) => m.provider === "openai")
            .map((model) => (
              <SelectItem key={model.id} value={model.id}>
                {model.name}
              </SelectItem>
            ))}
        </SelectGroup>
        <SelectGroup>
          <SelectLabel>Anthropic</SelectLabel>
          {availableModels
            .filter((m) => m.provider === "anthropic")
            .map((model) => (
              <SelectItem key={model.id} value={model.id}>
                {model.name}
              </SelectItem>
            ))}
        </SelectGroup>
        <SelectGroup>
          <SelectLabel>Gemini</SelectLabel>
          {availableModels
            .filter((m) => m.provider === "gemini")
            .map((model) => (
              <SelectItem key={model.id} value={model.id}>
                {model.name}
              </SelectItem>
            ))}
        </SelectGroup>
        <SelectGroup>
          <SelectLabel>Mock</SelectLabel>
          <SelectItem value="mock">Fake Messages</SelectItem>
          <SelectItem value="mock_slow">Fake Messages (slow)</SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
    // </div>
  );
};
